import { IMapper } from "../../interfaces/IMapper";
import { IAdvancedSearchRecentItem } from "../../interfaces/IAdvancedSearchRecentItem";
import dayjs from 'dayjs';

export class recentFilesAdvancedSearchMapper implements IMapper<IAdvancedSearchRecentItem[]> {
    constructor() { }

    static convertBytes = (bytes: number) => {
        const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

        if (bytes == 0) {
            return "n/a";
        }

        const i = Math.floor(Math.log(bytes) / Math.log(1024));

        if (i == 0) {
            return bytes + " " + sizes[i];
        }

        return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    }

    map(data: any): IAdvancedSearchRecentItem[] {
        return data.map((item) => <IAdvancedSearchRecentItem>({
            itemId: item?.id,
            driveId: item?.parentReference?.driveId,
            name: item?.name,
            modifiedValue: item?.lastModifiedDateTime?.valueOf(),
            modifiedText: dayjs(item?.lastModifiedDateTime).format("L"),
            sizeValue: item?.size,
            sizeText: recentFilesAdvancedSearchMapper.convertBytes(item?.size),
            modifiedBy: item?.lastModifiedBy?.user?.displayName,
            webUrl: item?.webUrl,
            isDocument: item?.file !== undefined,
            sharepointIds: item.sharepointIds
        }));
    }
}